import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import moment from "moment-timezone";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import HeaderBar from "../../components/header/HeaderBar";
import tournamentStatus from "../../constants/TournamentStatus";
import CloseTournamentContainer from "./CloseTournamentContainer";
import TournamentStatusContainer from "./TournamentStatusContainer";

class UserContainer extends Component {
  state = {
    tournaments: [],
    tournamentsLoaded: false,
    sharedTournaments: [],
    sharedTournamentsLoaded: false,
    upgrades: [],
    upgradesLoaded: false,
    user: {},
    userStatus: {},
    tournamentIdToMove: undefined,
    tournamentNameToMove: undefined,
    uidToMoveTo: undefined,
    moving: false,
    bulkMoveDialogOpen: false,
    bulkMoveUid: undefined,
    bulkMoving: false,
    bulkMoveError: "",
  };

  handleUserStatusChange = (e) => {
    e.preventDefault();
    let userStatus = this.state.userStatus;
    userStatus["status"] = e.target.value;
    window.firebase
      .firestore()
      .collection("userStatus")
      .doc(this.props.uid)
      .set(userStatus);
  };

  UNSAFE_componentWillMount = () => {
    if (!this.props.nvd && !this.props.tournamentList) {
      window.firebase
        .firestore()
        .collection("tournaments")
        .where("uid", "==", this.props.uid)
        .get()
        .then((querySnapshot) => {
          let tournaments = [];
          querySnapshot.forEach(function (doc) {
            let tournament = doc.data();
            tournament[".key"] = doc.id;
            tournament["id"] = doc.id;
            if (tournament.new !== true) {
              tournaments.push(tournament);
            }
          });
          tournaments.sort((a, b) => b.date - a.date);
          this.setState({ tournaments: tournaments, tournamentsLoaded: true });
        });
      window.firebase
        .firestore()
        .collection("tournaments")
        .where("admins", "array-contains", this.props.uid)
        .onSnapshot((querySnapshot) => {
          let tournaments = [];
          querySnapshot.forEach(function (doc) {
            let tournament = doc.data();
            tournament[".key"] = doc.id;
            tournament["id"] = doc.id;
            tournaments.push(tournament);
          });
          tournaments.sort((a, b) => b.date - a.date);
          this.setState({
            sharedTournaments: tournaments,
            sharedTournamentsLoaded: true,
          });
        });
      window.firebase
        .firestore()
        .collection("userStatus")
        .doc(this.props.uid)
        .onSnapshot((doc) => {
          let userStatus = doc.data();
          this.setState({ userStatus: userStatus || {} });
        });

      window.firebase
        .firestore()
        .collection("upgrades")
        .where("uid", "==", this.props.uid)
        .onSnapshot((querySnapshot) => {
          let upgrades = [];
          querySnapshot.forEach((doc) => {
            let upgrade = doc.data();
            upgrade["id"] = doc.id;
            if (!upgrade.payed) return;
            upgrades.push(upgrade);
          });
          upgrades.sort((a, b) => {
            const ta = a.timestamp?.toDate?.() || 0;
            const tb = b.timestamp?.toDate?.() || 0;
            return tb - ta;
          });
          this.setState({ upgrades, upgradesLoaded: true });
        });
    }
    window.firebase
      .firestore()
      .collection("users")
      .doc(this.props.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let user = doc.data();
          user["id"] = doc.id;
          this.setState({ user: user });
        }
      });
  };

  selectTournamentIdToMove = (id, name) => {
    console.log(id, name);
    this.setState({ tournamentIdToMove: id, tournamentNameToMove: name });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.handleMove(e);
    }
  };

  handleMove = () => {
    if (this.state.tournamentIdToMove && this.state.uidToMoveTo) {
      console.log(this.state.tournamentIdToMove, this.state.uidToMoveTo);
      this.setState({ moving: true, moveError: "" });
      window.firebase
        .firestore()
        .collection("users")
        .doc(this.state.uidToMoveTo)
        .get()
        .then((doc) => {
          if (doc.exists) {
            window.firebase
              .firestore()
              .collection("tournaments")
              .doc(this.state.tournamentIdToMove)
              .update({ uid: this.state.uidToMoveTo })
              .then(() => {
                this.setState({
                  tournamentIdToMove: undefined,
                  tournamentNameToMove: undefined,
                  uidToMoveTo: undefined,
                  moving: false,
                  moveError: "",
                });
              });
          } else {
            this.setState({ moveError: "User not found", moving: false });
          }
        });
    }
  };

  handleUidToMoveToChange = (e) => {
    this.setState({ uidToMoveTo: e.target.value });
  };

  upgradesForTournament = (tournamentId) =>
    this.state.upgrades.filter((u) => u.tournamentId === tournamentId);

  knownTournamentIdSet = () =>
    new Set([
      ...this.state.tournaments.map((t) => t[".key"]),
      ...this.state.sharedTournaments.map((t) => t[".key"]),
    ]);

  /** Upgrades whose tournament is not in this user's owned or shared lists (e.g. deleted). */
  getOrphanedUpgradeGroups = () => {
    const known = this.knownTournamentIdSet();
    const byTid = new Map();
    for (const u of this.state.upgrades) {
      const tid = u.tournamentId;
      if (tid && known.has(tid)) continue;
      const key = tid == null || tid === "" ? "__none__" : tid;
      if (!byTid.has(key)) byTid.set(key, []);
      byTid.get(key).push(u);
    }
    const groups = [];
    byTid.forEach((list, key) => {
      list.sort((a, b) => {
        const ta = a.timestamp?.toDate?.() || new Date(0);
        const tb = b.timestamp?.toDate?.() || new Date(0);
        return tb - ta;
      });
      groups.push({
        tournamentId: key === "__none__" ? null : key,
        upgrades: list,
      });
    });
    groups.sort((a, b) => {
      const ta = a.upgrades[0]?.timestamp?.toDate?.() || new Date(0);
      const tb = b.upgrades[0]?.timestamp?.toDate?.() || new Date(0);
      return tb - ta;
    });
    return groups;
  };

  renderUpgradeInvoiceList = (list) => {
    if (!list.length) {
      return "—";
    }
    return list.map((upgrade) => {
      const purchase =
        upgrade.timestamp && upgrade.timestamp.toDate
          ? moment(upgrade.timestamp.toDate()).format("DD-MM-YYYY")
          : "";
      const label = upgrade.invoiceStatus || "";
      const bracketed = purchase ? ` (${purchase})` : "";
      const inner = (
        <>
          {label}
          {bracketed}
        </>
      );
      return (
        <div key={upgrade.id} style={{ lineHeight: 1.4 }}>
          {upgrade.invoiceId ? (
            <a
              href={`https://app.jortt.nl/new_invoices/show/pp/aggregate_id/${upgrade.invoiceId}/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {inner}
            </a>
          ) : (
            inner
          )}
        </div>
      );
    });
  };

  renderUpgradeInvoices = (tournamentId) =>
    this.renderUpgradeInvoiceList(this.upgradesForTournament(tournamentId));
  chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  handleBulkMove = async () => {
    if (!this.state.bulkMoveUid) return;

    this.setState({ bulkMoving: true, bulkMoveError: "" });

    try {
      // Check if target user exists
      const userDoc = await window.firebase
        .firestore()
        .collection("users")
        .doc(this.state.bulkMoveUid)
        .get();

      if (!userDoc.exists) {
        this.setState({
          bulkMoveError: "Target user not found",
          bulkMoving: false,
        });
        return;
      }

      // Split tournaments into chunks of 20
      const chunks = this.chunkArray(this.state.tournaments, 20);
      let processed = 0;

      // Process each chunk
      for (const chunk of chunks) {
        const batch = window.firebase.firestore().batch();

        chunk.forEach((tournament) => {
          const tournamentRef = window.firebase
            .firestore()
            .collection("tournaments")
            .doc(tournament[".key"]);
          batch.update(tournamentRef, { uid: this.state.bulkMoveUid });
        });

        await batch.commit();
        processed += chunk.length;

        // Update progress in state
        this.setState({
          bulkMoveError: `Processed ${processed} of ${this.state.tournaments.length} tournaments...`,
        });
      }

      this.setState({
        bulkMoveDialogOpen: false,
        bulkMoveUid: undefined,
        bulkMoving: false,
        bulkMoveError: "",
      });
    } catch (error) {
      console.error("Error moving tournaments:", error);
      this.setState({
        bulkMoveError: "Error moving tournaments. Please try again.",
        bulkMoving: false,
      });
    }
  };

  handleBulkMoveUidChange = (e) => {
    this.setState({ bulkMoveUid: e.target.value });
  };

  render() {
    return this.props.admins.indexOf(this.props.user.uid) !== -1 ? (
      this.props.nvd || this.props.tournamentList ? (
        <span>{this.state.user.email}</span>
      ) : (
        <div style={{ width: "100%", marginTop: 80 }}>
          <HeaderBar user={this.props.user} />
          <div style={{ paddingLeft: 15 }}>
            Name: {this.state.user.firstName || ""} <br />
            Email: {this.state.user.email} <br />
            UID: {this.state.user.id}
            <br />
            Subscription:{" "}
            <Select
              style={{ maxWidth: "100%" }}
              value={this.state.userStatus.status || 0}
              onChange={this.handleUserStatusChange}
            >
              {Object.keys(tournamentStatus).map((key) => {
                let item = tournamentStatus[key];
                return (
                  <MenuItem key={key} value={Number(key)}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
            <br />
            <br />
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.setState({ bulkMoveDialogOpen: true })}
              style={{ marginTop: 10 }}
            >
              Move All Tournaments
            </Button>
          </div>
          {this.state.tournamentsLoaded &&
            this.state.sharedTournamentsLoaded &&
            this.state.upgradesLoaded && (
              <div style={{ display: "flex", gap: 10, padding: "0 10px" }}>
                <Paper>
                  <div style={{ padding: "0 15px" }}>
                    <h3>Tournaments</h3>
                  </div>
                  <Table size="small">
                    <TableBody>
                      {this.state.tournaments.map((tournament) => (
                        <TableRow key={tournament[".key"]}>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {moment.unix(tournament.date).format("D MMMM YYYY")}
                          </TableCell>
                          <TableCell>
                            <TournamentStatusContainer
                              tournamentId={tournament[".key"]}
                            />
                          </TableCell>
                          <TableCell
                            style={{ verticalAlign: "middle", minWidth: 210 }}
                          >
                            {this.renderUpgradeInvoices(tournament[".key"])}
                          </TableCell>
                          <TableCell
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                          >
                            <CloseTournamentContainer tournament={tournament} />
                          </TableCell>
                          <TableCell>
                            <Link
                              to={"/tournament/" + tournament[".key"]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {tournament.name}
                            </Link>
                          </TableCell>
                          <TableCell>
                            {tournament.liveLink && (
                              <a
                                href={
                                  "https://tournifyapp.com/live/" +
                                  tournament.liveLink
                                }
                                target="_blank"
                                alt=""
                                rel="noopener noreferrer"
                              >
                                Live
                                {/* {tournament.liveLink} */}
                              </a>
                            )}
                          </TableCell>
                          {/* <TableCell>
                            <Link
                              to={"/tournament/" + tournament[".key"]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open
                            </Link>
                          </TableCell> */}
                          <TableCell
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.selectTournamentIdToMove(
                                tournament[".key"],
                                tournament.name,
                              );
                            }}
                          >
                            Move
                          </TableCell>
                        </TableRow>
                      ))}
                      {this.getOrphanedUpgradeGroups().map((group) => {
                        const first = group.upgrades[0];
                        const dateCell = first?.timestamp?.toDate?.()
                          ? moment(first.timestamp.toDate()).format(
                              "D MMMM YYYY",
                            )
                          : "";
                        return (
                          <TableRow
                            key={`orphan-upgrade-${group.tournamentId || "none"}`}
                          >
                            <TableCell style={{ whiteSpace: "nowrap" }}>
                              {dateCell}
                            </TableCell>
                            <TableCell>—</TableCell>
                            <TableCell
                              style={{ verticalAlign: "middle", minWidth: 210 }}
                            >
                              {this.renderUpgradeInvoiceList(group.upgrades)}
                            </TableCell>
                            <TableCell
                              style={{ paddingLeft: 0, paddingRight: 0 }}
                            ></TableCell>
                            <TableCell>
                              <Typography variant="body2" component="span">
                                Tournament deleted ({group.tournamentId || "—"})
                              </Typography>
                            </TableCell>
                            <TableCell>—</TableCell>
                            <TableCell>—</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
                <Paper style={{ height: "0%" }}>
                  <div style={{ padding: "0 15px" }}>
                    <h3>Shared with this account</h3>
                  </div>
                  <Table size="small">
                    <TableBody>
                      {this.state.sharedTournaments.map((tournament) => (
                        <TableRow key={tournament[".key"]}>
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {moment.unix(tournament.date).format("D MMMM YYYY")}
                          </TableCell>
                          <TableCell>
                            <TournamentStatusContainer
                              tournamentId={tournament[".key"]}
                            />
                          </TableCell>
                          <TableCell
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                          >
                            <CloseTournamentContainer tournament={tournament} />
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Link
                              to={"/tournament/" + tournament[".key"]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {tournament.name}
                            </Link>
                          </TableCell>
                          <TableCell>
                            {tournament.liveLink && (
                              <a
                                href={
                                  "https://tournifyapp.com/live/" +
                                  tournament.liveLink
                                }
                                target="_blank"
                                alt=""
                                rel="noopener noreferrer"
                              >
                                Live
                                {/* {tournament.liveLink} */}
                              </a>
                            )}
                          </TableCell>
                          {/* <TableCell>
                            <Link
                              to={"/tournament/" + tournament[".key"]}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open
                            </Link>
                          </TableCell> */}
                          <TableCell
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.selectTournamentIdToMove(
                                tournament[".key"],
                                tournament.name,
                              );
                            }}
                          >
                            Move
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
          <Dialog
            open={this.state.tournamentIdToMove !== undefined}
            onClose={() => {
              this.setState({
                tournamentIdToMove: undefined,
                tournamentNameToMove: undefined,
                uidToMoveTo: undefined,
                moving: false,
                moveError: "",
              });
            }}
            aria-labelledby="form-dialog-title"
            disableBackdropClick
            disableEscapeKeyDown
          >
            <DialogTitle id="form-dialog-title">Move tournament</DialogTitle>
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <Typography>
                Move tournament <b>{this.state.tournamentNameToMove}</b> to new
                UID.
              </Typography>
              <TextField
                autoFocus
                fullWidth
                margin="normal"
                placeholder="UID"
                label="UID"
                value={this.state.uidToMoveTo || ""}
                onKeyDown={this.handleKeyDown}
                onChange={this.handleUidToMoveToChange}
                variant="outlined"
              />
              {this.state.moveError && (
                <Typography style={{ color: "red" }}>
                  {this.state.moveError}
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({
                    tournamentIdToMove: undefined,
                    tournamentNameToMove: undefined,
                    uidToMoveTo: undefined,
                    moving: false,
                    moveError: "",
                  });
                }}
                variant="contained"
              >
                Close
              </Button>
              <Button
                onClick={this.handleMove}
                variant="contained"
                color="primary"
                type="submit"
                disabled={this.state.moving || !this.state.uidToMoveTo}
              >
                Move
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.bulkMoveDialogOpen}
            onClose={() => {
              this.setState({
                bulkMoveDialogOpen: false,
                bulkMoveUid: undefined,
                bulkMoving: false,
                bulkMoveError: "",
              });
            }}
            aria-labelledby="bulk-move-dialog-title"
            disableBackdropClick
            disableEscapeKeyDown
          >
            <DialogTitle id="bulk-move-dialog-title">
              Move All Tournaments
            </DialogTitle>
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <Typography>
                Move all tournaments ({this.state.tournaments.length}) to new
                account
              </Typography>
              <TextField
                autoFocus
                fullWidth
                margin="normal"
                placeholder="Target UID"
                label="Target UID"
                value={this.state.bulkMoveUid || ""}
                onChange={this.handleBulkMoveUidChange}
                variant="outlined"
              />
              {this.state.bulkMoveError && (
                <Typography style={{ color: "red" }}>
                  {this.state.bulkMoveError}
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({
                    bulkMoveDialogOpen: false,
                    bulkMoveUid: undefined,
                    bulkMoving: false,
                    bulkMoveError: "",
                  });
                }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleBulkMove}
                variant="contained"
                color="primary"
                disabled={this.state.bulkMoving || !this.state.bulkMoveUid}
              >
                Move All
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    ) : (
      <div />
    );
  }
}

export default UserContainer;
